import * as React from "react";
import { SVGProps } from "react";
const SvgBulletlist = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path fill="currentColor" fillRule="evenodd" d="M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clipRule="evenodd" />
  </svg>
);
export default SvgBulletlist;
